import React, { PropsWithChildren } from "react";
import BoxItem, { IBoxItem } from "./BoxItem";

interface Props {
  title: string;
  items: IBoxItem[];
  cols?: 1 | 2;
  className?: string;
}

const Box: React.FC<PropsWithChildren<Props>> = (props): React.ReactElement => {
  const gridColsClass = props.cols ? "sm:grid-cols-2" : "sm:grid-cols-1";

  return (
    <div className={props.className ?? ""}>
      <div className="mb-2.5 px-3 text-[14px]/[16px] font-bold uppercase sm:px-5">
        {props.title}
      </div>
      <div className={`grid grid-cols-1 ${gridColsClass} gap-x-4 gap-y-1.5`}>
        {props.items
          .filter((x) => !x.hidden)
          .map((item) => (
            <BoxItem key={item.label} {...item} />
          ))}
      </div>
    </div>
  );
};

export default Box;
